import { useNavigation } from '@/shared/hooks/useNavigation'
import { useAuthActions } from '@/shared/lib/auth/actions'
import { Link } from '@/shared/ui/Link'

import styles from './styles.module.scss'

export const BottomNavItemContent = ({
  icon: Icon,
  name,
  active,
  label
}) => {
  const iconClass = active
    ? styles.BottomNavItemIconActive
    : styles.BottomNavItemIcon

  return (
    <span
      className={`${styles.BottomNavItemInner} ${
        active ? styles.BottomNavItemInnerActive : ''
      }`}
    >
      <span className={styles.BottomNavItemIconBox}>
        <Icon
          className={iconClass}
          variant={active ? 'solid' : 'duotone'}
          size={38}
        />
      </span>
      {name ? (
        <span className={styles.BottomNavItemLabel}>{label ?? name}</span>
      ) : null}
    </span>
  )
}

export const BottomNavItem = ({
  slug,
  href,
  onClick,
  icon,
  name,
  active,
  component,
  action,
  signOutOptions
}) => {
  const { basePathWithId } = useNavigation()
  const { signOut } = useAuthActions()

  if (component) {
    const Component = component

    return <Component key={slug} icon={icon} name={name} active={active} />
  }

  const LinkOrButton = ({ href, ...rest }) =>
    href ? <Link href={href} {...rest} /> : <button type="button" {...rest} />

  const handleClick = async event => {
    onClick?.(event)
    if (action === 'signOut') {
      event?.preventDefault?.()
      await signOut(signOutOptions)
    }
  }

  const content = (
    <>
      {active ? (
        <span className={styles.BottomNavItemActiveBar} aria-hidden="true" />
      ) : null}
      <BottomNavItemContent icon={icon} name={name} active={active} />
    </>
  )

  if (action === 'signOut') {
    return (
      <button
        type="button"
        onClick={handleClick}
        className={styles.BottomNavItemLink}
      >
        {content}
      </button>
    )
  }

  return (
    <LinkOrButton
      href={href ? `${basePathWithId}${href}` : undefined}
      onClick={handleClick}
      className={styles.BottomNavItemLink}
    >
      {content}
    </LinkOrButton>
  )
}
